import React from 'react'
import { Form, Label, Input, FormFeedback, FormGroup } from "reactstrap";
import './CreateProfile.css'

const Createprofile = (props) => {
    return (
        <div className='Createprofile'>
            <Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
                <FormGroup>
                    <Label className='heading'>Name</Label>
                    <span className="required-field"></span>
                    <Input invalid={props.nameinvalid} value={props.namevalue} onChange={props.handleNameChange}
                        className='field' placeholder='Type your first name and last name…' />
                    <FormFeedback>Name field cannot be empty</FormFeedback>
                </FormGroup>
                <FormGroup>
                    <Label className='heading'>Short Name</Label>
                    <span className="required-field"></span>
                    <Input invalid={props.shortNameinvalid} value={props.shortNamevalue} onChange={props.handleShortNameChange}
                        className='field' placeholder='Type your short name…' />
                    <FormFeedback>Short Name field cannot be empty</FormFeedback>
                </FormGroup>

                <div className='create-profile-buttons'>
                    <input type="reset" className='reset' value="RESET" />
                    <input type="submit" value='SUBMIT' className='submit' />
                </div>
            </Form>
        </div>
    )
}

export default Createprofile


// WEBPACK FOOTER //
// ./src/new/Components/View-Or-Edit-profile/CreateProfile/CreateProfile.jsx